import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminAffiliates() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/affiliates").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try { await api.patch(`/admin/affiliates/${id}`, patch); toast.success("Updated"); load(); }
    catch (e) { toast.error("Update failed"); }
  };

  return (
    <div data-testid="admin-affiliates-page">
      <div className="eyebrow mb-2">Partners</div>
      <h1 className="aperture-h1 text-4xl mb-10">Affiliates.</h1>
      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Name","Email","Code","Status","Commission","Clicks","Sales","Actions"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan="8" className="px-4 py-10 text-center text-navy/50">No applications yet.</td></tr>}
            {list.map((a) => (
              <tr key={a.id} className="border-t" data-testid={`aff-row-${a.referral_code}`} style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3">{a.name}</td>
                <td className="px-4 py-3">{a.email}</td>
                <td className="px-4 py-3 font-mono text-xs">{a.referral_code}</td>
                <td className="px-4 py-3">
                  <select value={a.status} onChange={(e)=>update(a.id, { status: e.target.value })} data-testid={`aff-status-${a.referral_code}`} className="text-xs border rounded-sm px-2 py-1 bg-white" style={{ borderColor: "rgba(10,37,64,0.15)" }}>
                    <option value="pending">pending</option><option value="approved">approved</option><option value="rejected">rejected</option>
                  </select>
                </td>
                <td className="px-4 py-3">
                  <input type="number" defaultValue={a.commission_pct} onBlur={(e)=>{const v=parseFloat(e.target.value); if(v!==a.commission_pct) update(a.id, { commission_pct: v });}} className="w-16 text-xs border rounded-sm px-2 py-1" style={{ borderColor: "rgba(10,37,64,0.15)" }} />%
                </td>
                <td className="px-4 py-3">{a.total_clicks}</td>
                <td className="px-4 py-3">${a.total_sales.toFixed(2)}</td>
                <td className="px-4 py-3 text-gold">${a.total_commission.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
